module.exports = __webpack_public_path__ + "img/elevator_opening02.abef104f.gif";